export default __webpack_public_path__ + "../staticImages/sprite-hermespaketshop-2x.png";